export default __webpack_public_path__ + "static/media/13117 - Godmosword.8906100e.jpeg";